import { render } from "./ModalHeader.vue?vue&type=template&id=38bb4668&scoped=true&ts=true"
import script from "./ModalHeader.vue?vue&type=script&lang=ts"
export * from "./ModalHeader.vue?vue&type=script&lang=ts"

import "./ModalHeader.vue?vue&type=style&index=0&id=38bb4668&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bb4668"]])

export default __exports__